import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-bar-chart',
	templateUrl:'./AgBarChartPluginCompPage.html',
	styles: [],
	styleUrls:['./AgBarChartPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgBarChartPluginCompPage
{
	mdContent_698 = `\`\`\`java
import com.jwebmp.plugins.agcharts.AgBarChart;
\`\`\``;
	mdContent_699 = `\`\`\`java
AgBarChart(String id, String xKey, String yKey)
\`\`\``;
}
